<template>
  <div>
    <h3>{{ msg }}</h3>
  </div>
</template>

<script>
export default {
  name: 'notFound',
  data () {
    return {
      msg: ''
    }
  }
}
</script>


// WEBPACK FOOTER //
// Nothing.vue?872afa1c